import { Capacitor } from '@capacitor/core';

/**
 * Detect if the app is running as a native mobile app (Capacitor iOS/Android)
 * This is used to hide payment-related features that must go through app stores
 */
export const isNativeApp = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Detect if running specifically on iOS (native app)
 */
export const isIOSApp = () => {
  return Capacitor.getPlatform() === 'ios';
};

/**
 * Detect if running specifically on Android (native app)
 */
export const isAndroidApp = () => {
  return Capacitor.getPlatform() === 'android';
};

/**
 * Detect if running as PWA (installed web app)
 */
export const isPWA = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
};

/**
 * Check if we should hide payment/subscription features
 * Hide on native apps (iOS/Android) due to app store policies
 */
export const shouldHidePaymentFeatures = () => {
  return isNativeApp();
};
